export const Translate = [
    {
        "Home": {
            "REGISTER": "CADASTRAR NOVO LOCAL",
            "TITLE_HOME": "O melhor lugar para oferecer tudo para PETS.",
            "SUBTITLE": "Cadastre abaixo seu estabelecimento em nosso sistema e alcance milhares de novos clientes que usam nosso aplicativo!",
        },

        "CreatePoint": {
            "BACK_HOME": "Voltar para home",
            "NEW_POINT": "Cadastro de novo estabelecimento",
            "DATA": "Dados",
            "POINT_NAME": "Nome do estabelecimento*",
            "POINT_NAME_EXAMPLE": "Ex.: Aviário do seu Pedro",
            "EMAIL": "E-mail*",
            "EMAIL_EXAMPLE": "Ex.: aviario@example.org",
            "WHATSAPP": "Whatsapp",
            "PHONE": "Telefone fixo",
            "ADDRESS": "Endereço",
            "SELECT_ADDRESS": "Selecione o endereço no mapa *",
            "STATE": "Estado (UF)",
            "SELECT_STATE": "Selecione um estado  ▼",
            "CITY": "Cidade",
            "SELECT_CITY": "Selecione uma cidade  ▼",
            "POSTAL_CODE": "CEP",
            "HOUSE_NUMBER": "Número do imóvel",
            "STREET": "Nome da rua",
            "STREET_EXAMPLE": "Ex.: Rua Julio Peréz",
            "COMPLEMENT": "Complemento",
            "COMPLEMENT_EXAMPLE": "Ex.: Casa branca",
            "SERVICE_CATEGORY": "Categorias de serviço",
            "SELECT_CATEGORY": "Selecione uma ou mais categorias",
            "OTHER_SERVICES": "Outros serviços",
            "SUBMIT": "Cadastrar estabelecimento",
            "SUCCESS_MESAGE": "Estabalecimento cadastrado com sucesso!"
        }
    }
]


